module.exports = __webpack_public_path__ + "static/media/AboutUsInactive.7359b819.svg";